<app-powerbi-content [data]="powerbiData" *ngIf="powerbiData"></app-powerbi-content>

<div class="all-charts" *ngIf="charts?.length">
  <ng-container *ngFor="let chart of charts">
    <app-chart-view [chartData]="chart"></app-chart-view>
  </ng-container>
</div>

<div class="component-cards">
  <div class="component-card"
       *ngFor="let data of allData | search:searchQuery | fullSort:filterType:reverseArray"
       [class.highlighted]="data.report_highlighted === 'highlighted'">

    <div class="component-card__header">
      <div class="component-card__title" [innerHTML]="data.post_name | texthighlight: searchQuery"></div>
      <div class="component-card__icon" [ngStyle]="{'background': getSystemInfo(data.report_type).bg}">
        <i class="ti" [class]="getSystemInfo(data.report_type).icon"
           [ngStyle]="{'color': getSystemInfo(data.report_type).color}"></i>
      </div>
    </div>

    <p class="component-card__desc"
       *ngIf="data.post_content"
       [innerHTML]="data.post_content | texthighlight:searchQuery"></p>

    <div class="component-card__footer">
      <ng-container *ngIf="getReportCategories(data) as cats">
        <span class="component-card__tag-dept" *ngIf="cats.length > 0">{{ cats[0] }}</span>
        <span class="component-card__tag component-card__tag--neutral" *ngFor="let cat of cats.slice(1)">{{ cat }}</span>
      </ng-container>
      <span class="component-card__tag" [ngClass]="'system-' + getSystemInfo(data.report_type).cssClass">
        {{ getSystemInfo(data.report_type).label }}
      </span>
      <span class="component-card__fav" *ngIf="showFavoriteIconCompletely"
            (click)="toggleFavoriteReport(data.post_id, data.report_favorited)">
        <i class="ti" [class.ti-heart-filled]="data.report_favorited" [class.ti-heart]="!data.report_favorited"></i>
      </span>
    </div>

    <a *ngIf="data.external_url" href="{{data.external_url}}" target="_blank"
       class="component-card__link" (click)="updateReportCounters(data.post_id)"></a>
  </div>

  <div *ngIf="showEmptyIcon && allData.length === 0" class="component-cards__empty">
    <p>No reports to show.</p>
  </div>
  <div *ngIf="showEmptyIcon && allData.length > 0 && (allData | search:searchQuery).length === 0"
       class="component-cards__empty">
    <p>No reports match your search.</p>
  </div>
</div>
